import Chip from '@mui/material/Chip'
import Autocomplete from '@mui/material/Autocomplete'
import TextField, { TextFieldProps } from '@mui/material/TextField'
import SearchIcon from '@mui/icons-material/Search'
import { Grid, IconButton, Tooltip } from '@mui/material'
import { CSSProperties, useEffect, useRef, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'

export default function SingleValueSearch(props: {
	isDisable?: boolean
	value: (string | never[])[]
	sx?: CSSProperties
    setGlobalSearch?: Function
	handleOnSearch: (selectedValue: (string | never[])[]) => void
}) {
	const { value, sx, handleOnSearch, setGlobalSearch } = props
	const [singleSelectedValue, setSingleSelectedValue] = useState('')

	const handleKeyDown = (event:any) => {
		if(event.key === 'Enter'){
			handleOnSearch([singleSelectedValue])
		}
	};

	useEffect(()=>{
		if(value.length){
            setSingleSelectedValue(value[0] as string)
        }
	}, [value])

	const handleChange = (inputValue:string) => {
		setSingleSelectedValue(inputValue)
	}

    const handleRemove = () => {
        setSingleSelectedValue('');
        if(typeof setGlobalSearch === "function"){
            setGlobalSearch([])
        }
    }
	return (
		<Grid
			container
			alignItems={'center'}
			sx={
				sx ?? {
					width: '30%',
					padding: '8px',
				}
			}
		>
			<Grid item xs={9}>
				<TextField
					onChange={(event) => {
						handleChange(event.target.value)
					}}
					value={singleSelectedValue || ''}
					variant="standard"
					sx={{ width: '100%'}}
					type={'text'}
                    onKeyDown={handleKeyDown}
				/>
			</Grid>
            <Grid item xs={1}>
				<Tooltip title={"remove"} placement={"top"}>
					<IconButton onClick={handleRemove} disabled={singleSelectedValue?.length === 0}>
						<CloseIcon />
					</IconButton>
				</Tooltip>
				
			</Grid>
			<Grid item xs={1}>
                <Tooltip title={"search"} placement={"top"}>
                    <IconButton
                        onClick={() => {
                            handleOnSearch([singleSelectedValue])
                        }}
                    >
                        <SearchIcon color="info" />
                    </IconButton>
                </Tooltip>
				
			</Grid>
		</Grid>
	)
}